export default {
  setLoading(state, isLoading) {
    state.loading = isLoading;
  },
  setForm(state, form = {}) {
    Object.assign(state.form, form);
  },
  setDownloadLink(state, downloadLink) {
    state.downloadLink = downloadLink;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/occurrences-validation/store/mutations.js